"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MONTHS_IN_YEAR = 12;
/** How much months to place in row on calendar page. */

exports.MONTH_PAGE_WIDTH = 3;